<template>
  <v-row class="align-content-start">
    <v-col
        v-if="banners.secondMonthPayment"
        class="d-flex justify-start col-lg-8 col-xl-4 offset-lg-2 offset-xl-4 col-12 pr-7"
        cols="12"
    >
      <div
        class="banner-wrapper"
      >
        <div
          class="banner-title"
        >
          {{ $t('common.specialOffer') }}
        </div>
        <div class="banner-subtitle">
          {{ $t('common.secondMonthPayment1') }}
          <span class="discount-block">30%</span>
          {{ $t('common.secondMonthPayment2', ['SAFE30']) }}
        </div>
        <div class="banner-renew">
          <v-btn
            color="primary"
            height="42"
            class="banner-renew-button"
            @click="handleRenew"
          >
            {{ $t('overview.renew') }}
            <img :src="leftArrow" alt="Left arrow icon" class="banner-renew-button-image" />
          </v-btn>

          <div class="banner-timer-wrapper">
            <div class="banner-timer-title">
              {{ $t('common.offerValid') }}
            </div>
            <img :src="stopWatch" alt="Watch icon" />
            <div class="banner-timer-time">
              {{ timer }}
            </div>
          </div>
        </div>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
import { mapFields } from "vuex-map-fields";
import leftArrow from '../../assets/leftArrow.svg'
import stopWatch from '../../assets/stopwatch.svg'
import moment from "moment";

  export default {
    name: 'SecondMonthPaymentBanner',

    data () {
      return {
        timer: '00:00:00', // 60 minutes timer
        leftArrow,
        stopWatch,
        timerInterval: null
      }
    },

    computed: {
      ...mapGetters({
        banners: 'main/banners',
        profile: 'main/profile',
        showBannerSecondMonthOfferUntil: 'main/showBannerSecondMonthOfferUntil'
      }),
      ...mapFields('plans', ['paymentInfo']),
    },

    async created () {
      const until = moment(this.showBannerSecondMonthOfferUntil)
      const now = moment(new Date())
      const duration = moment(until).diff(now, 'seconds', false)

      this.startTimer(duration);
      this.paymentInfo.plan = this.profile.subscription.plan;
      this.paymentInfo.profilesCount = this.profile.subscription.browserProfiles.count;
    },

    destroyed() {
      clearInterval(this.timerInterval)
    },

    methods: {
      startTimer (duration) {
        let timer = duration;

        this.timerInterval = setInterval(() => {
          const now = new Date().toISOString();
          const until = moment(this.showBannerSecondMonthOfferUntil);
          const difference = moment(now).diff(until, 'seconds', false)

          this.timer = moment.utc(timer * 1000).format('HH:mm:ss');

          if (--timer < 0) {
            timer = duration;
          }

          if (difference >= 0) {
            this.$store.dispatch('main/hideBanner', 'secondMonthPayment')
          }
        }, 1000);
      },

      async handleRenew () {
        this.paymentInfo.plan = this.profile.subscription.plan
        await this.$store.dispatch('main/setRenewSecondMonthWithDiscount', true)
        this.paymentInfo.profilesCount = this.profile.subscription.browserProfiles.limit
        await this.$store.dispatch('plans/openDialog', 'prolongPlan')
        await this.$store.dispatch('plans/setPaymentInfoPromocode', 'SAFE30')
      }
    }
  }
</script>

<style scoped>
  .banner-wrapper {
    border-radius: 16px;
    width: 100%;
    margin-bottom: 20px;
    margin-top: 30px;
    background: #404040 url('../../assets/percent.svg') no-repeat right;
    background-size: contain;
    padding: 28px;
  }

  .banner-renew {
    margin-top: 20px;
    display: flex;
    align-items: center;
  }

  .banner-renew-button {
    border-radius: 40px;
    font-weight: 600;
    font-size: 14px;
    line-height: 16px;
  }

  .banner-renew-button-image {
    margin-left: 13px;
  }

  .banner-title {
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    letter-spacing: 0.15px;
    color: #FFFFFF;
    opacity: 0.8;
  }

  .banner-subtitle {
    margin-top: 8px;
    font-weight: 500;
    font-size: 22px;
    line-height: 135%;
    letter-spacing: 0.15px;
    color: #FFFFFF;
  }

  .discount-block {
    height: 30px;
    background: #FFFFFF;
    border-radius: 100px;
    color: #000000;
    padding: 4px 9px;
  }

  .banner-timer-wrapper {
    height: 42px;
    background: #4A4A4A;
    border-radius: 50px;
    margin-left: 8px;
    display: flex;
    align-items: center;
    padding: 0 20px;
  }

  .banner-timer-title {
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    letter-spacing: 0.15px;
    color: #FFFFFF;
    margin-right: 10px;
  }

  .banner-timer-time {
    font-weight: 700;
    font-size: 24px;
    line-height: 28px;
    display: flex;
    align-items: center;
    letter-spacing: 0.15px;
    color: #FFFFFF;
    margin-left: 10px;
  }
</style>